import { atom } from 'jotai';

export const localeAtom = atom<'ja' | 'en'>('ja');
